import { mobileNavigation } from '../mobile-navigation';
import { menuHandler } from '../menu';
class HeaderCoordinator {
    constructor(debug = false) {
        this.isInitialized = false;
        this.debug = false;
        this.lastActionTimestamp = 0;
        this.cooldownPeriod = 100;
        this.debug = debug;
        this.log('HeaderCoordinator instantiated');
    }
    init() {
        if (this.isInitialized) {
            this.log('Already initialized, skipping');
            return;
        }
        this.log('Initializing header coordinator...');
        document.addEventListener('mobile-nav:opened', () => {
            this.log('Mobile nav opened - closing search overlay');
            this.closeSearchOverlay();
        });
        document.addEventListener('menu:opened', (event) => {
            const detail = event.detail;
            const searchMenu = detail.element;
            if (searchMenu && searchMenu.getAttribute('data-menu') === 'search-overlay') {
                this.log('Search overlay opened - closing mobile nav');
                const mobileNav = mobileNavigation.getInstance();
                if (mobileNav && mobileNav.isNavigationOpen()) {
                    this.closeMobileNav(true, true);
                    setTimeout(() => {
                        const searchInput = document.getElementById('txtPopUpSearchKey');
                        if (searchInput) {
                            searchInput.focus();
                            this.log('Focused search input after mobile nav close');
                        }
                    }, 50);
                }
            }
        });
        this.isInitialized = true;
        this.log('Header coordinator initialized successfully');
    }
    closeSearchOverlay() {
        try {
            menuHandler.closeAllMenus(false);
            this.log('Closed all menus (including search)');
        }
        catch (error) {
            console.error('Error closing search overlay:', error);
        }
    }
    closeMobileNav(skipHistory = false, skipFocusReturn = false) {
        try {
            const mobileNav = mobileNavigation.getInstance();
            if (mobileNav && mobileNav.isNavigationOpen()) {
                mobileNav.close({ skipHistory, skipFocusReturn });
                this.log('Closed mobile navigation', { skipHistory, skipFocusReturn });
            }
        }
        catch (error) {
            console.error('Error closing mobile nav:', error);
        }
    }
    log(...args) {
        if (this.debug) {
            console.log('[HeaderCoordinator]', ...args);
        }
    }
    destroy() {
        this.log('Destroying header coordinator');
        this.isInitialized = false;
    }
}
export const headerCoordinator = new HeaderCoordinator(false);
export const initHeaderCoordinator = () => {
    headerCoordinator.init();
};
